import React from 'react'
import useMediaQuery from '../../../shared/utils/useMediaQuery'
import flechas from '../../../assets/images/modals/flechas.png'
import person from '../../../assets/images/modals/person-game-1.png'
import txtimg from '../../../assets/images/modals/txt-game-1.png'


import './modalPubertad.scss'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'

const ModalPubertad = ({ handleCTA }) => {
  const isMobile = useMediaQuery()

  return (
    <div className='f-pubertad-container'>
      <div className='f-pubertad-container__wrapper'>
        <div className='f-pubertad-container__content'>
          <div className='f-pubertad-container__content-img'>
            <h2>Nivel 1</h2>

            <img src={txtimg} className='f-pubertad-container__content-img-txt' />
            <img src={person} className='f-pubertad-container__content-img-person' />

          </div>
          <div className='f-pubertad-container__content-txt'>
            <p>
              <b>La Pubertad</b> es ese momento en el que comenzamos a experimentar cambios físicos y hormonales, que
              marcan
              esta etapa de una forma inolvidable. Algunos días podés sentirte más sensible, otros días más alegre…
              pero <b>¡no te preocupés!</b> Es perfectamente normal.
            </p>

            <p>
              <b>En este juego,</b> a medida que avances, ganarás por el tiempo
              que estés en la pista. <b>Cuando choqués con 3 síntomas, el juego se terminará.</b>
            </p>
            <div className='f-pubertad-container__content-txt-instruction'>
              {isMobile ? (
                <p>Mové el personaje usando, de manera sostenida, las flechas de arriba y abajo de tu pantalla.</p>
              ) : (
                <p>Mové el personaje usando, de manera sostenida, las flechas de arriba y abajo de tu teclado.</p>
              )}
              <img src={flechas} />
            </div>


            <div className='f-pubertad-container__content-txt-img'>
              <img src={txtimg} className='f-pubertad-container__content-img-txt--mobile' />

            </div>
            <div className='f-pubertad-container__content-txt-btn'>
              <button onClick={() => {
                pushEventDataLayer('Personajes :: Juego', 'Nivel 1', 'QUIERO JUGAR')
                handleCTA()
              }}>
                QUIERO JUGAR
              </button>
            </div>
            <div className='f-pubertad-container__content-txt-img'>
              <img src={person} className='f-pubertad-container__content-img-person--mobile' />

            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalPubertad
